/**
 * 首页路由
 * 2017-12-6
 */
"use strict";
angular.module("homeInformationRouter", []).
config(["$stateProvider", function($stateProvider) {
    $stateProvider.state("homeinformation", {
        url: "/homeinformation?id&type",
        views: {
            "": {
                template: '<div class="view_head" ui-view="header"></div>' +
                    '<div class="view_body">' +
                    '<div class="" ui-view="main"></div>' +
                    '</div>'
            },
            "header@homeinformation": {
                templateUrl: 'header/headerDetails_tpl.html',
                controller: 'webHeaderCtrl'
            },
            "main@homeinformation": {
                templateUrl: "./main/homePage/homeInformation/homeInformation_tpl.html",
                controller: "homeInformationCtrl"
            }
        }
    });
}]);